
  import drawings_moduleRoutes from 'modules/drawings/app/module-routes';
  export const moduleRoutes = [
    ...drawings_moduleRoutes,
  ];
  